const indianFormatter = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
});

const numberFormat = (value) => {
    if (value === null || value === undefined || Number.isNaN(value)) {
        return "-";
    }
    return indianFormatter.format(value);
};

export default numberFormat;